<template>
  <div class="rootDiv">
    <div>
      <Divider>我管理的圈子</Divider>
    </div>
    <div v-if="ManagerCircleList.length>0">
      <ul v-for="item in ManagerCircleList" :key="item.qZNM">
        <li style="min-height: 60px">
          <CellSwipe v-on:click.native="Details(item)" is-link>
            <div class="mint-cell-title"
                 style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
              <label class="mint-checklist-label"
                     style="text-align: left;margin:0.4rem;">
                <div style="float: left;">
                  <avatar slot="icon" class="avatar" username="Birth Circle"
                          :src="item.qZTB"
                          :size="48">
                  </avatar>
                </div>
                <div style="float: left;margin-top: 0.5rem;margin-left: 0.6rem">
                  <div>
                    <span style="color: green;font-size: 1.2rem">{{ item.qZMC }}</span>
                  </div>
                  <div>
                    <span style="font-size: 0.8rem">管理员：</span>
                    <span style="font-size: 0.8rem;color: blue">{{ item.administrator }}</span>
                  </div>
                </div>
              </label>
            </div>
          </CellSwipe>
        </li>
      </ul>
    </div>
    <div>
      <Divider>我加入的圈子</Divider>
    </div>
    <div v-if="JoinCircleList.length>0">
      <ul v-for="item in JoinCircleList" :key="item.qZNM">
        <li style="min-height: 60px">
          <CellSwipe style="margin-top: -0.5rem;" v-on:click.native="Details(item)" is-link>
            <div class="mint-cell-title"
                 style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
              <label class="mint-checklist-label"
                     style="text-align: left;margin:0.4rem;">
                <div style="float: left;">
                  <avatar slot="icon" class="avatar" username="Birth Circle"
                          :src="item.qZTB"
                          :size="48">
                  </avatar>
                </div>
                <div style="float: left;margin-top: 0.5rem;margin-left: 0.6rem">
                  <div>
                    <span style="color: green;font-size: 1.2rem">{{ item.qZMC }}</span>
                  </div>
                  <div>
                    <span style="font-size: 0.8rem">管理员：</span>
                    <span style="font-size: 0.8rem;color: blue">{{ item.administrator }}</span>
                  </div>
                </div>
              </label>
            </div>
          </CellSwipe>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {CellSwipe} from 'mint-ui';
import {Divider} from 'vant';
import Avatar from 'vue-avatar'
import 'vant/lib/divider/index.css'

export default {
  name: "CircleManager",
  components: {CellSwipe, Avatar, Divider},
  data() {
    return {
      ManagerCircleList: [],
      JoinCircleList: [],
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      getCircleListUrl: '/api/circle/getCircleList',
    }
  },
  mounted() {
    this.getCircleList()
  },
  methods: {
    async getCircleList() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getCircleListUrl,
        params: {yhnm: that.yhnm},
        headers: {token: that.token}
      }).then((response) => {
        if (response.data.result) {
          let temp = response.data['responseData']
          temp.forEach(item => {
            if (item.qZTB == null) {
              const data = require('/public/config/data.json')
              item.qZTB = data['defaultGroupUrl']
            }
            if (item.qZGLY === that.yhnm) {
              that.ManagerCircleList.push(item)
            } else {
              that.JoinCircleList.push(item)
            }
          })
        } else {
          that.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    Details(item) {
      this.$router.push({name: 'm_circle_details', params: {circle: JSON.stringify(item)}})
    },
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  ul {
    list-style-type: none;
    margin: 0;

    li {
      height: 3rem;
      //margin-left: -2.5rem;
    }
  }
}

/deep/ .mint-cell-wrapper {
  min-height: 60px;
}
</style>
